import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, CustomSelect, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import SortBy from '../../SortBy';
import { Filter, FiltersWrapper } from './style';
import { getFilterLabel } from '../../../../utils/labels';

export const ModalFiltersId = 'ModalFilters';

const ModalFilters = ({
  mediaIsPhone,
  children,
  modalClose,
  onClick,
  onClickAlt,
  filters = {},
  activeFilters = {},
  sorting,
}) => {
  const scrollableAreaRef = useRef(null);
  const [selectedFilters, setSelectedFilters] = useState({});

  useEffect(() => {
    return () => {
      modalClose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedFilters({ ...activeFilters });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(activeFilters).length]);

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value || value?.id;
    setSelectedFilters(newFilters);
  };

  const formatOptions = (options = []) => {
    const opts = (options || []).map((o) => {
      if (o?.key && o?.value) {
        return {
          label: o?.value,
          value: o?.key,
        };
      }
      return o;
    });
    return opts;
  };

  const getSelectedFilter = (key) => {
    if (!selectedFilters[key]) return null;
    return formatOptions(filters[key]).find(
      (o) => (o?.value || o?.id) === selectedFilters[key]
    );
  };

  return (
    <Modal
      title="Filtri"
      modalId={ModalFiltersId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea ref={scrollableAreaRef}>
        {Object.keys(filters)?.length > 0 && (
          <>
            <Text type="b3" mb={8}>
              Seleziona i filtri da applicare:
            </Text>
            <FiltersWrapper>
              {Object.keys(filters).map((key, i) => {
                if (filters[key]?.length <= 0) return null;
                return (
                  <Filter key={`filter-${i}`}>
                    <CustomSelect
                      placeholder={getFilterLabel(key)}
                      options={formatOptions(filters[key])}
                      onChange={(value) => handleOnChange({ key, value })}
                      isClearable
                      selected={getSelectedFilter(key)}
                    />
                  </Filter>
                );
              })}
              {children}
            </FiltersWrapper>
          </>
        )}
        <SortBy
          options={sorting}
          onChange={(v) => {
            setSelectedFilters({
              ...selectedFilters,
              sort_by: v?.value,
            });
          }}
        />
      </ScrollableArea>
      <Footer>
        <CTA
          type="primary"
          btnText="Applica"
          fullsize={mediaIsPhone}
          onClick={() => {
            onClick && onClick(selectedFilters);
            onClickAlt && onClickAlt(selectedFilters);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalFilters.propTypes = {
  onClick: PropTypes.func,
  onClickAlt: PropTypes.func,
  children: PropTypes.node,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  filters: PropTypes.object,
  activeFilters: PropTypes.object,
  sorting: PropTypes.array,

  // dispatch
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { filters, activeFilters, sorting, onClickAlt } =
        state.app.modal.payload;
      return { filters, activeFilters, sorting, onClickAlt };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
    })
  ),
  withMediaQueries
)(ModalFilters);
